import { prescriptionMode } from '@/constants/constants';
import { useExerciseLibrary } from '@/zustand/exercise-library';
import { clearExerciseLibraryEditPrescriptionId } from '@/utils/exercise-library-page-helpers';
import { clearPrescriptionBuilderDraft } from '@/utils/prescription-builder-draft';

/**
 * Wipes prescription-builder persistence and exercise-library zustand state.
 * Invoked when auth ends (logout, failed refresh, login screen) so tokens and builder state stay aligned.
 */
export function resetExerciseLibrarySession() {
  try {
    clearPrescriptionBuilderDraft();
    clearExerciseLibraryEditPrescriptionId();
    localStorage.removeItem('hasSelectedCard');
  } catch {
    // ignore storage failures (private mode, quota)
  }
  useExerciseLibrary.setState({
    mode: prescriptionMode.PRESCRIPTION,
    openNotesView: false,
    EditTemplateData: [],
    selectedCard: [],
  });
}
